/**
 * @file Defines the {@link InputFilter} class.
 * @author Joe Thompson <joe.thompson@1x2network.com>
 */

/** Class for filtering input */
export class InputFilter {

    /**
     * Reference to HTML node
     * @memberof InputFilter
     * @protected
     * @instance
     * @type {HTMLElement}
     */
    _elem

    /** Initialise HTML node */
    constructor(elem_) {
        this._elem = elem_
    }

    /**
     * Filter input based on function passed in
     * @param {function} func_ - Input filter
     */
    filter(func_) {

        let _this = this; //Store reference to scope

        //For each input type
        ["input", "keydown", "keyup", "mousedown", "mouseup", "select", "contextmenu", "drop"].forEach(e_ => {

            //Add event listener
            _this._elem.addEventListener(e_, function() {

                //If value is permitted
                if (func_(this.value)) {
                    
                    this.oldValue          = this.value          //Store old value to current value
                    this.oldSelectionStart = this.selectionStart //Store old selection start state
                    this.oldSelectionEnd   = this.selectionEnd   //Store old selection end state

                } 
              
                //Value is not permitted
                else if (this.hasOwnProperty("oldValue")) {
                    
                    this.value = this.oldValue                                           //Set value to previous value
                    this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd) //Set text selection to previous state

                } 
                
                //If oldValue property not supported
                else {
                    this.value = "" //Clear value
                }

            })

        })

    }

}